import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../localization/language';
import { getFullMobileNo, sLvList } from '../../utils';
import * as mobileActions from '../../actions/mobile';
import * as emailActions from '../../actions/email';
import * as realinfoActions from '../../actions/realinfo';
import * as verifyEmailActions from '../../actions/verifyEmail';
import * as passwordActions from '../../actions/password';
import { COUNTRY_NEED_REAL_INFO } from '../../constants';
import MainElement from './MainElement';

class SecurityLevel extends React.Component {
	componentDidMount() {
		sLvList();
	}

	handleVerifyEmail() {
		this.props.initVerifyEmail();
	}

	handleRealinfo() {
		this.props.initRealinfo();
	}

	handleBindMobile() {
		this.props.initMobile();
	}

	handleAddEmail() {
		this.props.initEmail();
	}

	handleChangePassword() {
		this.props.initPassword();
	}

	computeSecurityPoint() {
		var points = 0;
		if (this.props.userInfo.password_s > 2) {
			points += (this.props.userInfo.password_s == 4) ? 20 : 10;
		}
		if (this.props.userInfo.email_v) {
			points += 30;
		}
		if (this.props.userInfo.mobile_no) {
			points += 50;
		}
		if (this.props.userInfo.authenticator_enable) {
			points += 10;
		}
		return points;
	}

	renderSecurityGauge() {
		var points = this.computeSecurityPoint();
		var scale = points * 337 / 100;
		if (points >= 100 && this.props.userInfo.password_s > 2) {
			return (
				<div className="securitylv-gauge">
					<div className="securitylv-gauge__svg-wrap">
						<svg className="securitylv-gauge__svg" viewBox="0 0 125 125" preserveAspectRatio="xMinYMin">
							<circle className="securitylv-gauge__bg" cx="50%" cy="50%" r="43%" strokeWidth="17"></circle>
							<circle className="securitylv-gauge__arc" cx="50%" cy="50%" r="43%" strokeWidth="17" stroke="#00D26A" strokeDasharray="340,337"></circle>
						</svg>
					</div>
					<div className="securitylv-gauge__txt">
						{trans('security_level_high')}
					</div>
				</div>
			);
		} else if (points >= 50 && this.props.userInfo.password_s > 2) {
			return (
				<div className="securitylv-gauge">
					<div className="securitylv-gauge__svg-wrap">
						<svg className="securitylv-gauge__svg" viewBox="0 0 125 125" preserveAspectRatio="xMinYMin">
							<circle className="securitylv-gauge__bg" cx="50%" cy="50%" r="43%" strokeWidth="17"></circle>
							<circle className="securitylv-gauge__arc" cx="50%" cy="50%" r="43%" strokeWidth="17" stroke="#FFDB00" strokeDasharray={scale.toString() + ",337"}></circle>
						</svg>
					</div>
					<div className="securitylv-gauge__txt">
						{trans('security_level_medium')}
					</div>
				</div>
			)
		}
		return (
			<div className="securitylv-gauge">
				<div className="securitylv-gauge__svg-wrap">
					<svg className="securitylv-gauge__svg" viewBox="0 0 125 125" preserveAspectRatio="xMinYMin">
						<circle className="securitylv-gauge__bg" cx="50%" cy="50%" r="43%" strokeWidth="17"></circle>
						<circle className="securitylv-gauge__arc" cx="50%" cy="50%" r="43%" strokeWidth="17" stroke="#FF9100" strokeDasharray={scale.toString() + ",337"}></circle>
					</svg>
				</div>
				<div className="securitylv-gauge__txt">
					{trans('security_level_low')}
				</div>
			</div>
		);
	}

	renderSecurityWarnAction() {
		var points = this.computeSecurityPoint();
		if (points < 100) {
			return (
				<Link to="/security" className="securitylv-warn__item">
					<div className="securitylv-warn__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('security_action_warn')}
					</div>
					<div className="securitylv-warn__operation">
						{trans('action')}
					</div>
				</Link>
			);
		} else {
			return (
				<a href="#" className="securitylv-warn__item" onClick={this.handleChangePassword.bind(this)}>
					<div className="securitylv-normal__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('high_security_level_message')}
					</div>
				</a>
			)
		}
	}

	renderSecurityWarnEmail() {
		if (!this.props.userInfo.email) {
			return (
				<a href="#" className="securitylv-warn__item" onClick={this.handleAddEmail.bind(this)}>
					<div className="securitylv-warn__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('security_email_warn')}
					</div>
					<div className="securitylv-warn__operation">
						{trans('add_action')}
					</div>
				</a>
			);
		} else if (!this.props.userInfo.email_v) {
			return (
				<a href="#" className="securitylv-warn__item" onClick={this.handleVerifyEmail.bind(this)}>
					<div className="securitylv-warn__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('security_verify_email_warn', [this.props.userInfo.email])}
					</div>
					<div className="securitylv-warn__operation">
						{trans('verify_action')}
					</div>
				</a>
			);
		}
	}
	renderSecurityWarnRealinfo() {
		if (!this.props.userInfo.realname) {
			return (
				<a href="#" className="securitylv-warn__item" onClick={this.handleRealinfo.bind(this)}>
					<div className="securitylv-warn__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('have_not_linked_id_card')}
					</div>
					<div className="securitylv-warn__operation">
						{trans('Link')}
					</div>
				</a>
			);
		}
	}

	renderSecurityWarnMobile() {
		if (!this.props.userInfo.mobile_no) {
			return (
				<a href="#" className="securitylv-warn__item" onClick={this.handleBindMobile.bind(this)}>
					<div className="securitylv-warn__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('security_mobile_warn')}
					</div>
					<div className="securitylv-warn__operation">
						{trans('bind_action')}
					</div>
				</a>
			);
		}
	}

	renderSecurityWarnPassword() {
		if (this.props.userInfo.password_s <= 2) {
			return (
				<a href="#" className="securitylv-warn__item" onClick={this.handleChangePassword.bind(this)}>
					<div className="securitylv-warn__icon"></div>
					<div className="securitylv-warn__txt">
						{trans('security_password_warn')}
					</div>
					<div className="securitylv-warn__operation">
						{trans('enhance_action')}
					</div>
				</a>
			);
		}
	}

	renderSecurityWarn() {
		return (
			<div className="securitylv-warn">
				{this.renderSecurityWarnAction()}
				{this.renderSecurityWarnMobile()}
				{this.renderSecurityWarnEmail()}
				{this.props.language&&COUNTRY_NEED_REAL_INFO.indexOf(this.props.language.country)>=0? this.renderSecurityWarnRealinfo(): null}
				{this.renderSecurityWarnPassword()}
			</div>
		);
	}

	renderSecurityNormalPassword() {
		if (this.props.userInfo.password_s >= 3) {
			return (
				<div className="securitylv-normal__item">
					<div className="securitylv-normal__icon"></div>
					<div className="securitylv-normal__txt">
						{(this.props.userInfo.password_s === 4) ? trans('security_normal_password_strong') : trans('security_normal_password_medium')}
					</div>
				</div>
			);
		}
	}

	renderSecurityNormalMobile() {
		if (this.props.userInfo.mobile_no) {
			const full_mobile_no = getFullMobileNo(this.props.userInfo);
			return (
				<div className="securitylv-normal__item">
					<div className="securitylv-normal__icon"></div>
					<div className="securitylv-normal__txt">
						{trans('security_normal_mobile', [full_mobile_no])}
					</div>
				</div>
			);
		}
	}

	renderSecurityNormalRealinfo() {
		if (this.props.userInfo.realname) {
			return (
				<div className="securitylv-normal__item">
					<div className="securitylv-normal__icon"></div>
					<div className="securitylv-normal__txt">
						{trans('have_linked_id_card')} {this.props.userInfo.idcard}
					</div>
				</div>
			);
		}
	}

	renderSecurityNormalEmail() {
		if (this.props.userInfo.email_v) {
			return (
				<div className="securitylv-normal__item">
					<div className="securitylv-normal__icon"></div>
					<div className="securitylv-normal__txt">
						{trans('security_normal_email', [this.props.userInfo.email])}
					</div>
				</div>
			);
		}
	}

	renderSecurityNormal() {
		return (
			<div className="securitylv-normal-wrap" id="J-slv-nor-wrap">
				<div className="securitylv-normal" id="J-slv-nor">
					{this.renderSecurityNormalPassword()}
					{this.renderSecurityNormalEmail()}
					{this.renderSecurityNormalMobile()}
					{this.props.language&&COUNTRY_NEED_REAL_INFO.indexOf(this.props.language.country)>=0? this.renderSecurityNormalRealinfo() : null}
				</div>
			</div>
		);
	}

	renderSecurityPanelWrap() {
		return (
			<div className="securitylv-panel-wrap">
				<a href="javascript:;" className="securitylv-panel" id="J-slv-nor-trigger">
					<div className="securitylv-panel__txt">
						<span className="securitylv-panel__txt-view">{trans('view')}</span>
						<span className="securitylv-panel__txt-collapse">{trans('collapse')}</span> {trans('completed_items')}
					</div>
				</a>
			</div>
		);
	}

	renderSecurityContent() {
		return (
			<div className="securitylv-content">
				{this.renderSecurityWarn()}
				{this.renderSecurityNormal()}
				{this.renderSecurityPanelWrap()}
			</div>
		)
	}

	render() {
		return (
			<MainElement title={trans('security_level_title')}>
				<div className="securitylv">
					{this.renderSecurityGauge()}
					{this.renderSecurityContent()}
				</div>
			</MainElement>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, mobileActions, emailActions, verifyEmailActions, passwordActions, realinfoActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SecurityLevel);


// WEBPACK FOOTER //
// ./app/components/home/SecurityLevel.js